<template>
    <div id="app">

        <div id="calendar-main">
            <v-card id="calendar-card">
                <div id="calendar-card-header">
                    <div id="calendar-card-header-left-area"></div>
                    <div id="calendar-card-header-left-mid-area">
                        <v-btn :disabled="disableBack" icon @click="$refs.calendar.prev()">
                            <v-icon >mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-btn :disabled="disableNext" icon @click="$refs.calendar.next()">
                            <v-icon >mdi-chevron-right</v-icon>
                        </v-btn>
                    </div>
                    <div id="calendar-card-header-mid-area">
                        <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                transition="fade-transition"
                                offset-y
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field style="padding-top: 30px"
                                        v-model="computedFormatDate"
                                        append-icon="fas fa-angle-down"
                                        outlined
                                        @click:append="menu = true"
                                        rounded
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                    :max="todaysDate"
                                    min="2019-08-01"
                                    dark
                                    color="white"
                                    v-model="date"
                                    no-title
                                    type="month"
                                    scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="white" @click="menu = false">Close</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </div>

                    <div style="width: 25%; height: 100%; float: left; display: flex; justify-content: center; align-items: center;">

                        <div style="width: 50%; height: 100%; float: left; display: flex; justify-content: center; align-items: center">

                            <v-avatar
                            color="#519ca5"
                            size="30"
                            style="display: flex;justify-content: center; align-items: center"
                            >
                                <span style="font-size: 2vh; color: white">UK</span>
                            </v-avatar>

                        </div>

                        <div style="width: 50%; height: 100%; float: left; display: flex; justify-content: center; align-items: center">
                        <v-avatar
                                    color="#fabe3f"
                                    size="30"
                                    style="display: flex;justify-content: center; align-items: center"
                            >
                                <span style="font-size: 2vh; color: white">AUS</span>
                            </v-avatar>
                        </div>
                    </div>
                </div>
                <div id="calander-component">
                    <v-card id="calander-component-card">
                        <v-calendar
                                ref="calendar"
                                type="month"
                                color="grey darken-3 white--text"
                                light
                                :event-more="false"
                                :event-height="17"
                                v-model="date"
                                :events="events"
                                :event-color="getEventColor"
                                :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                        ></v-calendar>
                    </v-card>
                </div>
            </v-card>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Vuetify from 'vuetify'
    import 'vuetify/dist/vuetify.min.css'
    import {AXIOS} from "../../../http-common";
    import VueApexCharts from 'vue-apexcharts'
    import FlagIcon from 'vue-flag-icon'

    Vue.use(FlagIcon);
    Vue.use(Vuetify)

    export default {
        components: {},
        props: [],
        data () {
            return {
                disableBack: false,
                disableNext: true,
                todaysDate: new Date().toISOString().substr(0, 10),
                // date: new Date().toISOString().substr(0, 10),
                date: new Date().toISOString().substr(0, 10),
                menu: false,
                startDate: new Date().toJSON(),
                events: [],
            }
        },
        watch: {
            'date': function (d, d1) {
                if (d.length != 10){
                    this.date = d+ "-01"
                }
                if (d != d1){
                    this.menu = false
                }
                var selectedDate = d.substr(0,7)
                var currentDate = new Date().toJSON().substr(0,7)

                if (selectedDate >= currentDate){
                    this.disableNext = true
                }
                else if (selectedDate <= '2019-08'){
                    this.disableBack = true
                }
                else {
                    this.disableNext = false
                    this.disableBack = false
                }
            }
        },
        created: function () {
            this.getCalendarAmounts()
        },
        computed: {
            computedFormatDate () {
                return new Date(this.date).toLocaleString('default', { month: 'long' }) + " " + new Date(this.date).getFullYear()
            },
        },
        methods: {
            getCalendarAmounts(){
                Promise.all([
                    AXIOS.get('/api/orders/stats/calendar/daily/uk', {headers: {
                            Authorization: 'Bearer ' + window.$cookies.get('session')
                        }}  ),
                    AXIOS.get('/api/orders/stats/calendar/daily/aus', {headers: {
                            Authorization: 'Bearer ' + window.$cookies.get('session')
                        }}),
                ])
                    .then(((response) => {
                        var responseDateUk = response[0].data
                        var responseDateAus = response[1].data

                        var p = 0;
                        while (p < responseDateUk.length){
                            var calendarUkAmount = responseDateUk[p][4].toFixed(2)
                            var calendarUkDate =  responseDateUk[p][2] + '-'+ responseDateUk[p][0] + "-" + responseDateUk[p][1]

                            this.todayPush =  {
                                name: "£" + calendarUkAmount,
                                start: calendarUkDate,
                                end: calendarUkDate,
                                color: '#519ca6',
                            },
                                this.events.push( this.todayPush);
                            p++
                        }
                        var i = 0;
                        while (i < responseDateAus.length){
                            var calendarAusAmount = responseDateAus[i][4]
                            var calendarAusDate =  responseDateAus[i][2] + '-'+ responseDateAus[i][0] + "-" + responseDateAus[i][1]

                            this.todayPush =  {
                                name: "$" + calendarAusAmount.toFixed(2),
                                start: calendarAusDate,
                                end: calendarAusDate,
                                color: '#fabe3f',
                            },
                                this.events.push( this.todayPush);
                            i++
                        }
                    }))
            },

            getEventColor (event) {
                return event.color
            },

            getEventName (event) {
                return event.name
            },
        }

    }
</script>

<style scoped>
    html, body {
        height: 100%;
        margin: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        background-color: white;

        width: 100%;
        height: 100%;
        background-size: cover;
        overflow: hidden;
        /*padding: 1%;*/
    }
    #calendar-main {
        width: 100%; height: 100%; padding-left: 0.5%; padding-right: 0.5%; padding-top: 1%; padding-bottom: 1%
    }
    #calendar-card {
        width: 100%; height: 100%
    }
    #calander-component {
        width: 100%; height: 85%
    }
    #calander-component-card {
        width: 100%; height: 100%
    }
    #calendar-card-header {
        width: 100%; height: 15%; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 3vh
    }
    #calendar-card-header-left-area {
        width: 15%; height: 100%; float: left; display: flex; justify-content: center; align-items: center;
    }
    #calendar-card-header-left-mid-area {
        width: 20%; height: 100%; float: left; display: flex; justify-content: center; align-items: center;
    }
    #calendar-card-header-mid-area {
        width: 40%; height: 100%; display: flex; justify-content: center; align-items: center;
    }

</style>
